__webpack_require__.p = "/TypingNinja/";